/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A_RecordInputs */

const en_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Record:`)
};

const es_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro A:`)
};

const fr_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement A :`)
};

const de_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A-Record:`)
};

const ja_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aレコード:`)
};

const zh_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 记录：`)
};

const ar_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل A:`)
};

const id_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record A:`)
};

const it_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record A:`)
};

const ru_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись A:`)
};

const pt_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro A:`)
};

const ko_a_record = /** @type {(inputs: A_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 레코드:`)
};

/**
* | output |
* | --- |
* | "A Record:" |
*
* @param {A_RecordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const a_record = /** @type {((inputs?: A_RecordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A_RecordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_a_record(inputs)
	if (locale === "es") return es_a_record(inputs)
	if (locale === "fr") return fr_a_record(inputs)
	if (locale === "de") return de_a_record(inputs)
	if (locale === "ja") return ja_a_record(inputs)
	if (locale === "zh") return zh_a_record(inputs)
	if (locale === "ar") return ar_a_record(inputs)
	if (locale === "id") return id_a_record(inputs)
	if (locale === "it") return it_a_record(inputs)
	if (locale === "ru") return ru_a_record(inputs)
	if (locale === "pt") return pt_a_record(inputs)
	return ko_a_record(inputs)
});